import React, { useState, useEffect, useCallback, useContext } from "react";
import SearchIcon from '@material-ui/icons/Search';
import AlarmIcon from '@material-ui/icons/Alarm';
import HistoryIcon from '@material-ui/icons/History';
import StarIcon from '@material-ui/icons/Star';
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import FilterListIcon from '@material-ui/icons/FilterList';
import TreeItem from '@material-ui/lab/TreeItem';
import { Folder, FolderOpen } from "@material-ui/icons";

function FilterFolder({match, history, folder, onItemSelect}){

    const getFilterIcon= (f)=>{
        switch(f.id){
            case 0:{
              //ALL
              return <FilterNoneIcon/>;
            }
            case -1:{
              return  <SearchIcon/>;
            }
            case -2:{
              //BOOKMARKS
              return  <StarIcon/>;
            }
            case -3:{
              //RECENT
              return  <HistoryIcon/>;
            }
            case -40:{
              //SESSION
              return  <AlarmIcon/>;
            }
            default:{
                return <></>
            }
          }
    }

    const showFilter= (filter)=>{
        console.log("showing filter", filter);
        let url = "/app/content/" +
        match.params.money +
        "/" +
        match.params.sessionType+"/"+match.params.hero +"/session/"+filter.id+"/"+match.params.sort+"/"+match.params.dir ;
        console.log("showing url", url);
        history.push(url);
        onItemSelect();
    }
    
    

    useEffect(()=>{
        console.log("folder", folder);
    });

    return (
    <TreeItem nodeId={"folder-"+folder.id} label={folder.name===""?"Root":folder.name} className={"menu"} expandIcon={<Folder/>} collapseIcon={<FolderOpen/>}>
        {folder.folders.map(child=><FilterFolder folder={child}/>)}
        {folder.filters.map(filter=><TreeItem nodeId={"filter-"+filter.id} icon={getFilterIcon(filter)} label={filter.name} onClick={()=>showFilter(filter)} className={"menu-item"+(parseInt(match.params.nodeId)===filter.id?" selected":"")}/>)}
    </TreeItem>);
}
export default FilterFolder;